// src/pages/Authentication/ResetPassword.js
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
} from "reactstrap";

// Import ikon
import { FaEye, FaEyeSlash } from "react-icons/fa";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { Link, useNavigate, useLocation } from "react-router-dom";

// Import service API
import { changePassword } from "../../services/authService"; // Pastikan path ini benar

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logo.svg";

const ResetPassword = () => {
  document.title = "Reset Password | Skote - React Admin & Dashboard Template";

  const navigate = useNavigate();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [passwordUpdateSuccess, setPasswordUpdateSuccess] = useState("");
  const [passwordUpdateError, setPasswordUpdateError] = useState("");

  const [secret, setSecret] = useState(null);

  useEffect(() => {
    // Mengambil secret dari URL query parameter
    const queryParams = new URLSearchParams(location.search);
    const secretFromUrl = queryParams.get("secret");
    if (secretFromUrl) {
      setSecret(secretFromUrl);
    } else {
      setPasswordUpdateError("Secret key tidak ditemukan. Silakan coba lagi.");
    }
  }, [location]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      rePassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Password minimal 8 karakter")
        .required("Mohon masukkan password baru"),
      rePassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Password tidak cocok")
        .required("Mohon masukkan ulang password"),
    }),
    onSubmit: async (values) => {
      setPasswordUpdateSuccess("");
      setPasswordUpdateError("");

      if (!secret) {
        setPasswordUpdateError("Secret key tidak valid.");
        return;
      }

      try {
        const response = await changePassword(
          secret,
          values.password,
          values.rePassword
        );
        if (response.success) {
          setPasswordUpdateSuccess(
            "Password berhasil diubah. Anda akan diarahkan ke halaman login."
          );
          setTimeout(() => navigate("/login"), 3000);
        } else {
          setPasswordUpdateError(
            response.message || "Gagal mengubah password. Silakan coba lagi."
          );
        }
      } catch (error) {
        setPasswordUpdateError(
          error.response?.data?.message || "Terjadi kesalahan. Silakan coba lagi."
        );
      }
    },
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleRePasswordVisibility = () => {
    setShowRePassword((prev) => !prev);
  };

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Perbarui Password</h5>
                        <p>Masukkan password baru Anda.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {passwordUpdateSuccess && (
                        <Alert color="success">{passwordUpdateSuccess}</Alert>
                      )}

                      {passwordUpdateError && (
                        <Alert color="danger">{passwordUpdateError}</Alert>
                      )}

                      <div className="mb-3">
                        <Label className="form-label">Password Baru</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            name="password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Masukkan password baru"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          <button
                            className="btn btn-light"
                            type="button"
                            onClick={togglePasswordVisibility}
                          >
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                          </button>
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Ulangi Password</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            name="rePassword"
                            type={showRePassword ? "text" : "password"}
                            placeholder="Ulangi password baru"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.rePassword || ""}
                            invalid={
                              validation.touched.rePassword &&
                              validation.errors.rePassword
                                ? true
                                : false
                            }
                          />
                          <button
                            className="btn btn-light"
                            type="button"
                            onClick={toggleRePasswordVisibility}
                          >
                            {showRePassword ? <FaEye /> : <FaEyeSlash />}
                          </button>
                          {validation.touched.rePassword &&
                          validation.errors.rePassword ? (
                            <FormFeedback type="invalid">
                              {validation.errors.rePassword}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mt-4">
                        <button
                          className="btn btn-primary w-100"
                          type="submit"
                        >
                          Perbarui Password
                        </button>
                      </div>
                      <div className="mt-5 text-center">
                        <p>
                          Sudah Punya Akun?{" "}
                          <Link
                            to="/login"
                            className="font-weight-medium text-primary"
                          >
                            Login
                          </Link>
                        </p>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-4 text-center">
                <p className="mb-0">ASN Kedinasan Learning Center</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;